//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import { useSelector } from 'react-redux'
import { isDirty } from 'redux-form'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { ProjectStatusIdEnum } from 'config/enums'

const useCanUserDeleteProject = sourceForm => (
  useSelector(state => {
    // Make sure the form is pristine - this is set within the submit handler so that we know the selected results reflect the
    // current user in the search form.
    const formIsDirty = isDirty(sourceForm)(state)
    if (formIsDirty) {
      return false
    }

    // the user id and the projectStatus assigned to the project management search form
    const {
      createUserId: filteredUser,
      projectStatusId,
    } = state.form[sourceForm].values

    const currentUserIsFilteredUer = state.user.get('userId') === filteredUser.userId

    const currentUserIsEngineering = state.user.getIn(['permissions', 'engineering'])

    const filteredUserIsAutoPrt = filteredUser.userName === 'auto_prt'

    const filteredProjectStatusIsFinalized = castToFloat(projectStatusId) === ProjectStatusIdEnum.FINALIZED

    return (
      // anyone can delete a finalized project
      filteredProjectStatusIsFinalized ||
      // allow engineering users to delete Projects created by user auto_prt
      (currentUserIsEngineering && filteredUserIsAutoPrt) ||
      // but only the create user can delete it if the project is not finalized.
      currentUserIsFilteredUer
    )
  })
)

export default useCanUserDeleteProject
